<div id="new-recipe" class="px-05">
    <app-elaboration-form [elaboration]="content" [main]="true" (recipeFormEmit)="newRecipe( $event )"></app-elaboration-form>
</div>